import * as React from 'react';
import { Image } from '@msdyn365-commerce/core';
import { IImageProps } from '@msdyn365-commerce/core-internal/dist/types/components/image/image';

export default class BmaImage extends React.Component<IImageProps, any> {
    constructor(props: IImageProps) {
        super(props);
        this.state = { imageSrc: '' };
    }
    public async componentDidMount() {
        console.log('BmaImage component did mount');
        if (this.props.snapShotId) {
            await this.loadBmaImages();
        }
    }
    public async componentDidUpdate(previewProps: any) {
        console.log('BmaImage component did update');
        if (previewProps.productsCount !== this.props.productsCount && this.props.snapShotId) {
            await this.loadBmaImages();
        }
    }

    private loadBmaImages = async () => {
        if (this.props.requestContext) {
            const bmaImageEndPoint = this.props.requestContext.app.config.bmaImageEndPoint.replace('#snapshotId', this.props.snapShotId);

            const response = await fetch(`${this.props.requestContext.app.config.bmaBaseUrl}${bmaImageEndPoint}`);
            const images = await response.json();
            this.setState({ imageSrc: images[0] });
        }
    };
    public render(): JSX.Element | null {
        return (
            <Image
                requestContext={this.props.requestContext}
                className={this.props.removeClass ? '' : 'ms-wishlist-items__product-image'}
                altText={this.props.altText}
                title={this.props.title}
                src={this.state.imageSrc}
                fallBackSrc={this.props.fallBackSrc}
                gridSettings={this.props.gridSettings}
                imageSettings={this.props.imageSettings}
                loadFailureBehavior={this.props.loadFailureBehavior}
            />
        );
    }
}
